// TODO(refactor): shared cutting point interface
import type { ICuttingPoint } from '../../../frontend/apps/mba-cpr-survey-portal/src/app/features/private/tows/interface/cutting-point.interface';

export function getSilkRemaining(cuttingPoints: ICuttingPoint[], milesPerDivision: number) {
  if (!cuttingPoints) {
    return;
  }

  if (cuttingPoints.length <= 1) {
    return 0;
  }

  const cuts = [...cuttingPoints].sort((a, b) => b.sectionId - a.sectionId);

  return Math.round((cuts[0]!.cuttingPoint - cuts[1]!.cuttingPoint) * milesPerDivision * 1e3) / 1e3;
}
